module.exports = __webpack_public_path__ + "img/exit.d87809f3.svg";